module.exports = __webpack_public_path__ + "img/GAME-alt.fc4fcb76.svg";